export const iconFontAwesomeTransportationTruckFront = (
	<i className="fa-solid fa-truck-front"></i>
);
